// Generated by genversion.
export const version = '1.42.2';
